import { generateUserAgentHeader, urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const handleConsent = (patientId, action, osType, osVersion, app, appVersion, dataId) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'PUT',
            url: urls.apiUrl + 'v1/patients/' + patientId + '/consents',
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                id: dataId,
                action,
            },
        })
            .then((result) => {
            if (result.data) {
                return resolve(result.data);
            }
            reject();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
